// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"65053212","453":"93894272","455":"7ae6f9aa"}[chunkId] + ".chunk.js";
};